import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { CcHpiConstants } from '../store/ccHpi.constants'
import { ICcHpiInjuryDetailsState } from '../store/ccHpi.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getCcHpiInjuryDetailsSelector } from '../selectors/injuryDetails.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveCcHpiInjuryDetails() {
  const ccHpiInjuryDetails: ICcHpiInjuryDetailsState = yield select(getCcHpiInjuryDetailsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      ccHpiInjuryDetails,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveCcHpiInjuryDetails() error: ${e}`))
    }
  } else {
    yield put(throwPcrException('pcrID not found'))
  }
}

export function* saveCcHpiInjuryDetailsSaga() {
  yield takeLatest(
    [
      CcHpiConstants.SET_INTENTIONAL,
      CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK,
      CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_PNNV,
      CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK,
      CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_PNNV,
      CcHpiConstants.SET_INJURY_CAUSE,
      CcHpiConstants.SET_MECHANISM,
      CcHpiConstants.SET_MECHANISM_PNNV,
      CcHpiConstants.SET_SAFETY_EQUIPMENT,
      CcHpiConstants.SET_SAFETY_EQUIPMENT_PNNV,
      CcHpiConstants.SET_FALL_HEIGHT,
      CcHpiConstants.SET_FALL_SURFACE,
      CcHpiConstants.SET_LANDED_ON,
      CcHpiConstants.SET_WORK_RELATED,
      CcHpiConstants.SET_WORK_RELATED_PNNV,
    ],
    performWithMutexHOG,
    saveCcHpiInjuryDetails
  )
}
